import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "debitcategory",
  listKey: "categories",
  itemKey: "category",
  getAll: types.GET_ALL_DEBIT_CATEGORIES,
  getAllResponse: types.GET_ALL_DEBIT_CATEGORIES_RESPONSE,
  getByIdResponse: types.GET_DEBIT_CATEGORY_BY_ID_RESPONSE,
});
